<template>
  <div class="chat_lists">
    <div class="user_qs" v-if="message.role == 'user'">
      {{ message.content }}
    </div>
    <div class="answer" v-if="message.role == 'assistant'">
      <img
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/ava.png"
        alt=""
        class="answer_ava"
      />
      <span
        class="contentspan"
        v-if="message.status == 'loading'"
        style="display: flex; width: 120px"
        >正在分析问题
        <div class="dots"></div
      ></span>
      <div
        v-if="message.dataLists && message.status != 'loading'"
        class="contentspan"
      >
        <div v-for="(atem, i) in message.dataLists" :key="i">
          <div
            v-if="
              message.status != 'loading' &&
              (atem.contentType
                ? atem.contentType.value == 'object_string'
                : false)
            "
          >
            <span v-for="(item, index) in atem.content" :key="index">
              <!-- 文本类型 -->
              <div v-if="item.type == 'text'">
                {{ item.text }}
              </div>
              <!-- 图片类型 -->
              <div v-if="item.type === 'image'" class="media-content">
                <img
                  :src="item.file_url"
                  alt="图片"
                  class="media-element"
                  style="width: 300px"
                />
                <div
                  v-if="!item.file_url && !item.file_id"
                  class="missing-resource"
                >
                  [图片资源缺失]
                </div>
              </div>
              <!-- 文件类型 -->
              <div v-if="item.type === 'file'" class="file-content">
                <a :href="item.file_url" target="_blank" class="file-link">
                  <span class="file-icon">📄</span>
                  <span>下载文件</span>
                </a>
              </div>
              <!-- 音频类型 -->
              <div v-if="item.type === 'audio'" class="media-content">
                <audio controls class="media-element">
                  <source :src="item.file_url" type="audio/mpeg" />
                  您的浏览器不支持音频元素
                </audio>
                <div
                  v-if="!item.file_url && !item.file_id"
                  class="missing-resource"
                >
                  [音频资源缺失]
                </div>
              </div>
            </span>
          </div>
        </div>
        <div
          ref="markdownContainer"
          class="markdown_class"
          v-if="message.messagenew && message.messagenew != '无法作答'"
          :class="
            message.messagenew.includes('如果需要添加客服') ? 'img_code' : ''
          "
          v-html="compileMarkdown(message.messagenew)"
          :id="`copy-${uid}`"
        ></div>
        <!-- 卡片类 -->
        <div
          class="message_car"
          v-if="
            message.newDataLists &&
            message.newDataLists[message.newDataLists.length - 1] ==
              'end[commonReply]' &&
            message.newDataLists[1].type != 2
          "
        >
          <!-- 人群类 -->
          <div class="crowd">
            <span class="name">{{ message.newDataLists[1].name }}</span>
            <span class="desc">{{ message.newDataLists[1].desc }}</span>
            <div
              class="deleted"
              @click="deletedClick"
              v-if="message.newDataLists[1].deleted"
            >
              立即创建
            </div>
            <div v-else @click="addTemplate(message.newDataLists[1])">
              立即创建
            </div>
          </div>
        </div>
        <div
          class="message_car_new"
          v-if="
            message.newDataLists &&
            message.newDataLists[message.newDataLists.length - 1] ==
              'end[commonReply]' &&
            message.newDataLists[1].type == 2
          "
        >
          <!-- 互动类 -->
          <div class="interaction">
            <div class="img">
              <img :src="getPic(message.newDataLists[1].code)" alt="" />
            </div>
            <div class="name">{{ message.newDataLists[1].name }}</div>
            <div class="desc hidden-2">{{ message.newDataLists[1].desc }}</div>
            <div
              class="btn"
              @click="addInteraction(message.newDataLists[1].code)"
            >
              立即创建
            </div>
          </div>
        </div>
        <div
          v-if="message.messagenew && message.messagenew == '无法作答'"
          style="padding-bottom: 10px"
        >
          无法作答
        </div>
        <div
          class="yq_flex"
          v-if="
            message.status == 'finish' &&
            !message.messagenew.includes('如果需要添加客服')
          "
        >
          <div
            class="hover-effect"
            v-if="!message.likeStatus && !isLike"
            @click="changeStatus(2)"
          >
            <el-tooltip content="赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/like.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="message.likeStatus && isLike"
            @click="changeStatus(2)"
          >
            <el-tooltip content="赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/like2.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="!message.dislikeStatus && !isStepon"
            @click="changeStatus(4)"
          >
            <el-tooltip content="不赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/stepon.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="message.dislikeStatus && isStepon"
            @click="changeStatus(4)"
          >
            <el-tooltip content="不赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/stepon2.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect copy-btn"
            @click="copyText(message)"
          >
            <el-tooltip content="复制" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/copy.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <!-- <div class="hover-effect" v-if="isCopy" @click="changeStatus(6)">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/copy2.png" alt="" />
          </div> -->
          <div
            class="hover-effect"
            v-if="!isChangeanswer"
            @click="callParentMethod"
          >
            <el-tooltip content="重新生成" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/changeanswer.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <!-- <div class="hover-effect" v-if="isChangeanswer">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/changeanswer2.png" alt="" />
          </div> -->
        </div>
      </div>
      <div
        v-if="
          !message.dataLists &&
          message.status != 'loading' &&
          !message.questionData
        "
        class="contentspan"
      >
        <span
          v-if="message.content.contentType"
          :id="`copy-${uid}`"
          v-html="compileMarkdown(message.content.content)"
          :class="
            message.content.content.includes('如果需要添加客服')
              ? 'img_code'
              : ''
          "
          ref="messageNewContent"
        ></span>
        <span
          v-if="!message.content.contentType"
          v-html="message.content"
        ></span>
        <!-- <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/zhanwei.jpg"
          alt=""
          class="zhanwei"
          v-if="
            typeof message.content === 'string' &&
            message.content.includes('请扫码添加客服企业微信号~')
          "
        /> -->
        <div
          class="yq_flex"
          v-if="
            (message.status == 'finish' || message.status == 'abort') &&
            typeof message.content.content === 'string' &&
            !message.content.content.includes('如果需要添加客服')
          "
        >
          <div
            class="hover-effect"
            v-if="!message.likeStatus && !isLike"
            @click="changeStatus(2)"
          >
            <el-tooltip content="赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/like.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="message.likeStatus && isLike"
            @click="changeStatus(2)"
          >
            <el-tooltip content="赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/like2.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="!message.dislikeStatus && !isStepon"
            @click="changeStatus(4)"
          >
            <el-tooltip content="不赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/stepon.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect"
            v-if="message.dislikeStatus && isStepon"
            @click="changeStatus(4)"
          >
            <el-tooltip content="不赞同" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/stepon2.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div
            class="hover-effect copy-btn"
            @click="copyText(message)"
          >
            <el-tooltip content="复制" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/copy.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <!-- <div class="hover-effect" v-if="isCopy" @click="changeStatus(6)">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/copy2.png" alt="" />
          </div> -->
          <div
            class="hover-effect"
            v-if="!isChangeanswer"
            @click="callParentMethod"
          >
            <el-tooltip content="重新生成" placement="top">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/changeanswer.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <!-- <div class="hover-effect" v-if="isChangeanswer">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/changeanswer2.png" alt="" />
          </div> -->
        </div>
      </div>
      <div v-if="message.questionData" class="contentspan">
        <div class="ai_tips_box">
          <div class="ai_tips_box_tabchange">
            <div class="ai_tips_box_tip">
              {{
                message.questionData.textName == "人群策略推荐"
                  ? "Hi，我是AI人群营销策略助手，告知我活动节点、营销目的、人群特征等信息，帮您精准定位受众、提升营销效果"
                  : "Hi，我是AI智能提优助手，我可以帮助您优化策略"
              }}~
            </div>
            <div
              class="ai_tips_box_change"
              @click="changeQs(message.questionData.index)"
            >
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/changenew.png"
                alt=""
              />
              <span>换一换</span>
            </div>
          </div>
          <div class="ai_question" ref="aiQuestion">
            <div
              class="ai_question_list"
              v-for="(item, index) in message.questionData.data"
              @click="changeQuestion(item.recommendQuestion)"
              :key="index"
            >
              <div class="textName">
                {{ message.questionData.textName }}
              </div>
              <el-tooltip :content="item.recommendQuestion" placement="top">
                <span class="ellipsis">{{ item.recommendQuestion }}</span>
              </el-tooltip>
              <div
                class="ai_question_arrow"
                @click.stop="inputText(item.recommendQuestion)"
              >
                <img src="@/assets/images/ai/Frame.png" alt="" />
              </div>
              <!-- <i class="el-icon-arrow-right ai_question_arrow"></i> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="stop_all" v-if="message.status == 'abort'">已停止回答</div>
  </div>
</template>
<script>
import { marked } from "marked";
import { likeAndStep } from "@/api/ai/index.js";
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      isLike: false,
      isLikeSwitch: false,
      isStepon: false,
      isSteponSwitch: false,
      isCopy: false,
      isChangeanswer: false,
      uid: Math.random().toString(36).substring(2, 9),
      picList: [
        {
          id: 51,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/0ysy.png",
        },
        {
          id: 50,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/qshk.png",
        },
        {
          id: 48,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/dskj.png",
        },
        {
          id: 46,
          itemUrl:
            "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/maneyouli.png",
        },
        {
          id: 44,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/hysjl.png",
        },
        {
          id: 45,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfsq.png",
        },
        {
          id: 47,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/dcwj.png",
        },
        {
          id: 43,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/N_yuan.png",
        },
        {
          id: 41,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/yz_bg.png",
        },
        {
          id: 1,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/calendar-check-in.png",
        },
        {
          id: 4,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/gzdpyl-new.png",
        },
        {
          id: 17,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/first-order.png",
        },
        {
          id: 16,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/xdyl-new.png",
        },
        {
          id: 19,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/xdcj-new.png",
        },
        {
          id: 18,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/fgyl-new.png",
        },
        {
          id: 34,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jgyl-new.png",
        },
        {
          id: 36,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/xdcb-new.png",
        },
        {
          id: 27,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/ysyl-new.png",
        },
        {
          id: 28,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/yscj-new.png",
        },
        {
          id: 8,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/dzpcj-new.png",
        },
        {
          id: 7,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/wcxxyl-new.png",
        },
        {
          id: 20,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/pjyl-new.png",
        },
        {
          id: 3,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/mrxsx-new.png",
        },
        {
          id: 22,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/tjhby-new.png",
        },
        {
          id: 23,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/hlwwj-new.png",
        },
        {
          id: 24,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/djlzc-new.png",
        },
        {
          id: 5,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/yqkkyl-new.png",
        },
        {
          id: 6,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/yqgzyl-new.png",
        },
        {
          id: 21,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/lbsq-new.png",
        },
        {
          id: 31,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/cjlb-new.png",
        },
        {
          id: 39,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/sryl-new.png",
        },
        {
          id: 9,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfdhqsw-new.png",
        },
        {
          id: 10,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfdhyhq-new.png",
        },
        {
          id: 29,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfdhjd-new.png",
        },
        {
          id: 30,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfdhek-new.png",
        },
        {
          id: 38,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/jfdh-new.png",
        },
        {
          id: 13,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/kklb-new.png",
        },
        {
          id: 14,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/dplb-new.png",
        },
        {
          id: 15,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/dplbqr-new.png",
        },
        {
          id: 33,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/0ysy-new.png",
        },
        {
          id: 32,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/hykp-new.png",
        },
        {
          id: 26,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/ggl-new.png",
        },
        {
          id: 25,
          itemUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/znhdhb-new.png",
        },
      ],
    };
  },
  props: {
    message: {
      type: Object,
    },
    parentMethod: {
      type: Function,
      required: true,
    },
  },
  watch: {
    message: {
      handler(val) {
        console.log("newVal", val);
        if (this.message.status == "finish" && this.$refs.markdownContainer) {
          const links = this.$refs.markdownContainer.querySelectorAll("a");
          links.forEach((link) => {
            link.setAttribute("target", "_blank");
            // 建议同时添加 rel 属性以增强安全性
            link.setAttribute("rel", "noopener noreferrer");
          });
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    deletedClick() {
      this.$message.error("抱歉，该策略已被移除，暂时无法查看");
    },
    getPic(id) {
      let pic = this.picList.find((item) => item.id == id);
      return pic.itemUrl || "";
    },
    addTemplate(code) {
      sessionStorage.setItem("AICode", code);
      let routeUrl = this.$router.resolve({
        path: "/marketing/intelligent_market",
      });
      window.open(routeUrl.href, "_blank");
    },
    addInteraction(code) {
      sessionStorage.setItem("AICode", code);
      let routeUrl = this.$router.resolve({
        path: "/interactiveMarketing/interactiveSquare",
      });
      window.open(routeUrl.href, "_blank");
    },
    changeQuestion(qs) {
      this.$emit("changeQuestion", qs);
    },
    changeQs(index) {
      this.$emit("changeQs", index);
    },
    inputText(test) {
      this.$emit("inputText", test);
    },
    callParentMethod() {
      this.parentMethod(this.message.chatId);
    },
    compileMarkdown(text) {
      return marked(text); // 直接使用
    },
    copyText(text) {
      console.log("text111", text);
      let newText = "";
      if (text && text.messagenew) {
        newText = text.messagenew;
      } else {
        if (text && typeof text.content == "string") {
          newText = text.content;
        } else {
          newText = text.content.content;
        }
      }

      // 使用原生 Clipboard API 代替错误的构造函数使用
      if (navigator.clipboard && window.isSecureContext) {
        // 现代浏览器，使用 Clipboard API
        navigator.clipboard.writeText(newText).then(() => {
          this.$message.success("复制成功");
        }).catch(() => {
          this.$message.error("复制失败");
        });
      } else {
        // 降级方案：创建临时的 textarea 元素
        const textArea = document.createElement('textarea');
        textArea.value = newText;
        // 避免滚动到元素位置
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success("复制成功");
        } catch (err) {
          this.$message.error("复制失败");
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    changeStatus(status) {
      // console.log("cbs", this.message, this.isLikeSwitch);

      // console.log("ckc", this.message);

      if (status == 2) {
        if (this.message.likeStatus) {
          this.isLikeSwitch = true;
        } else {
          this.isLikeSwitch = false;
        }
        if (!this.isLikeSwitch) {
          this.isLikeSwitch = true;
          this.isLike = true;
          this.message.likeStatus = true;
          this.isStepon = false;
          this.isSteponSwitch = false;
          this.message.dislikeStatus = false;
          this.likeStep(1);
        } else {
          this.isLikeSwitch = false;
          this.isLike = false;
          this.message.likeStatus = false;
          this.likeStep(1);
        }
      } else if (status == 4) {
        if (this.message.dislikeStatus) {
          this.isSteponSwitch = true;
        } else {
          this.isSteponSwitch = false;
        }
        if (!this.isSteponSwitch) {
          this.isSteponSwitch = true;
          this.isStepon = true;
          this.message.dislikeStatus = true;
          this.isLike = false;
          this.isLikeSwitch = false;
          this.message.likeStatus = false;
          this.likeStep(2);
        } else {
          this.isSteponSwitch = false;
          this.isStepon = false;
          this.message.dislikeStatus = false;
          this.likeStep(2);
        }
      } else if (status == 5 || status == 6) {
        ElMessage({
          type: "success",
          message: "复制成功！",
        });
        toClipboard(this.message.content.content);
      }
    },
    async likeStep(type) {
      const { data } = likeAndStep({
        chatId: this.message.chatId,
        likeStatus: type == 2 ? false : this.isLike,
        dislikeStatus: type == 1 ? false : this.isStepon,
      });
    },
  },
  created() {
    this.isLike = this.message.likeStatus;
    // if (this.message.likeStatus) {
    //   this.isLikeSwitch = true;
    // } else {
    //   this.isLikeSwitch = false;
    // }
    // if (this.message.dislikeStatus) {
    //   this.isSteponSwitch = true;
    // } else {
    //   this.isLikeSwitch = false;
    // }
    // console.log("cns", this.isLikeSwitch);
    this.isStepon = this.message.dislikeStatus;
    setTimeout(() => {
      if (this.$refs.messageNewContent) {
        const links2 = this.$refs.messageNewContent.querySelectorAll("a");
        links2.forEach((link) => {
          link.setAttribute("target", "_blank");
          // 建议同时添加 rel 属性以增强安全性
          link.setAttribute("rel", "noopener noreferrer");
        });
      }
    }, 1000);
  },
};
</script>
<style lang="scss">
.ai-base {
  font-size: 16px !important;
  font-weight: bold !important;
  margin-bottom: 16px !important;
}
.ai-list {
  font-size: 14px !important;
  font-weight: 400 !important;
  margin-bottom: 8px !important;
  color: #000311 !important;
}
.ai-crowd,
.ai-suggest {
  font-size: 12px !important;
  font-weight: 400 !important;
  margin-bottom: 12px !important;
  color: #666 !important;
}
</style>
<style lang="scss" scoped>
.chat_lists {
  display: flex;
  flex-direction: column;
  .user_qs {
    margin-top: 20px;
    padding: 12px 16px 13px 16px;
    line-height: 21px;
    box-sizing: border-box;
    background: rgba(49, 89, 255, 0.8);
    box-shadow: 0px 2px 8px 0px rgba(127, 133, 233, 0.5);
    border-radius: 12px 12px 0px 12px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    display: inline-block;
    align-self: flex-end;
  }
  .answer {
    display: flex;
    margin-top: 20px;
    .answer_ava {
      width: 40px;
      height: 40px;
      display: block;
      margin-right: 8px;
    }
    .contentspan {
      background: #ffffff;
      box-shadow: 0px 0px 4px 0px #e9ecf9, 0px 4px 16px 0px #e1e9fc;
      border-radius: 12px 12px 12px 0px;
      padding: 12px 16px;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 12px;
      color: #1c1b44;
      max-width: 692px;
    }
  }
  .yq_flex {
    width: 100%;
    display: flex;
    padding-top: 9px;
    border-top: 1px dashed #f0f0f2;
    img {
      width: 12px;
      display: block;
      height: 12px;
      cursor: pointer;
    }
  }
  .zhanwei {
    width: 100px;
    height: 91px;
    border-radius: 4px 4px 0px 0px;
    margin-top: 12px;
    display: block;
  }
  .dots::after {
    content: "...";
    animation: dotAnimation 1.5s infinite step-end;
  }

  @keyframes dotAnimation {
    0%,
    33% {
      content: ".";
    }
    34%,
    66% {
      content: "..";
    }
    67%,
    100% {
      content: "...";
    }
  }
  .stop_all {
    background: #d7dff2;
    border-radius: 2px 2px 2px 2px;
    margin-left: 47px;
    margin-top: 8px;
    width: 58px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    font-weight: 400;
    font-size: 10px;
    color: #5f5e7b;
  }
}
.hover-effect:hover {
  background-color: #e6eaff;
  border-radius: 2px;
}
.hover-effect {
  margin-right: 8px !important;
  padding: 2px;
}
.ai_tips_box {
  // max-height: 355px;
  // height: 38vh;
  max-height: 405px;
  display: block;
  box-sizing: border-box;
  width: 660px;
  .ai_tips_box_icon {
    width: 57px;
    height: 62px;
    display: block;
    margin-top: -11px;
  }
  .ai_tips_box_tabchange {
    display: flex;
    height: 26px;
    align-items: center;
    justify-content: space-between;

    .ai_tips_box_tip {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 14px;
      color: #000311;
      flex: 1;
    }

    .ai_tips_box_change {
      display: flex;
      height: 26px;
      align-items: center;
      cursor: pointer;
      margin-left: 12px;
      img {
        width: 18px;
        height: 18px;
        display: block;
      }
      span {
        font-weight: 400;
        font-size: 12px;
        color: #3159ff;
        margin-left: 8px;
        line-height: 26px;
      }
    }
  }
  .ai_question {
    width: 100%;
    margin-top: 16px;
    // max-height: 184px;
    // height: calc(100% - 148px);
    // overflow: hidden;
    // overflow-y: scroll;
    .ai_question_list {
      width: 100%;
      padding: 12px;
      background: rgba(245, 247, 255, 1);
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 12px;
      color: #1c1b44;
      display: flex;
      align-items: center;
      // align-items: center;
      cursor: pointer;
      &:hover {
        background: rgba(230, 231, 240, 1);
      }
      > .textName {
        height: 17px;
        background: #eaeafe;
        border-radius: 2px 2px 2px 2px;
        padding: 0 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #4d42f5;
        margin-right: 8px;
        line-height: 17px;
      }
      > span {
        // 超过一行显示省略号
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .ellipsis {
        color: #666;
      }
      .ai_question_arrow {
        padding: 5px;
        img {
          width: 10px;
          height: 10px;
        }
        cursor: pointer;
        margin-left: 12px;
      }
    }
  }
}
.message_car {
  background: linear-gradient(316deg, #ffffff 0%, #f4f6ff 100%);
  border-radius: 11px 11px 11px 11px;
  padding: 16px 12px;
  margin-bottom: 27px;
  .crowd {
    width: 400px;
    height: 155px;
    padding: 0 20px;
    box-sizing: border-box;
    background-image: url("../../../assets/images/ai/crowd_car_bg1.png");
    padding-top: 30px;
    > .name {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000311;
      margin-bottom: 8px;
      display: block;
    }
    > .desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      margin-bottom: 24px;
      display: block;
      // 超过两行显示省略号
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    > div {
      width: 76px;
      height: 26px;
      background: #5a7aff;
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 26px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      cursor: pointer;
    }
    .deleted {
      background: #ddd !important;
      cursor: not-allowed !important;
    }
  }
}
.message_car_new {
  width: 230px;
  padding: 16px;
  box-sizing: border-box;
  // height: 364px;
  background: linear-gradient(316deg, #ffffff 0%, #f4f6ff 100%);
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #eaeaea;
  margin-bottom: 27px;
  .interaction {
    display: flex;
    flex-direction: column;
    align-items: center;
    .img {
      width: 198px;
      height: 202px;
      border-radius: 13px 13px 0px 0px;
      margin-bottom: 16px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-weight: 600;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
      text-align: left;
      width: 198px;
      margin-bottom: 12px;
    }
    .desc {
      width: 198px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      text-align: left;
      margin-bottom: 16px;
      height: 29px;
    }
    .btn {
      width: 139px;
      height: 33px;
      background: #e9f0ff;
      border-radius: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2768ff;
      text-align: center;
      line-height: 33px;
      cursor: pointer;
    }
  }
}
.hidden-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
}
</style>
<style lang="scss">
.contentspan {
  .img_code img {
    width: 150px !important;
    display: block;
  }
  .markdown_class {
    img {
      max-width: 400px;
      display: block;
      margin-top: 20px;
    }
  }
  ul,
  ol {
    margin-top: 10px !important;
    margin-bottom: 0 !important;
    margin-left: -3px;
    img {
      max-width: 400px;
      display: block;
      margin-top: 20px;
    }
  }
  ul {
    list-style-type: circle !important;
  }
  ol {
    list-style-type: decimal;
  }
  strong {
    font-size: 12px;
    font-weight: bolder;
  }
  li {
    margin-bottom: 20px !important;
    margin-left: 20px !important;
  }
  p {
    margin-bottom: 5px !important;
    white-space: break-spaces;
    line-height: 25px;
    font-weight: 400 !important;
    img {
      max-width: 400px;
    }
  }
  a {
    color: #3159ff !important;
    margin-top: 5px;
  }
  td,
  th {
    padding: 5px; /* 为所有单元格设置10px的内边距 */
  }
  table {
    border-collapse: separate;
    border-spacing: 0 5px; /* 水平间距为0，垂直间距为10px */
  }
}
</style>
